import React, { useState, useRef } from 'react';

/**
 * Notation GIFs/images: try /thumbnail, then /download, then optional legacy static URL
 * (metadata.notation_image). Hides the section only if every step fails — avoids losing
 * notation when asset routes misbehave for some GIFs but a static file still exists.
 */
export default function NotationAssetImg({
  assetId,
  title,
  hideSectionOnTotalFailure = true,
  fallbackUrl = '',
}) {
  /** 0 = thumbnail, 1 = download, 2 = legacy fallback */
  const [step, setStep] = useState(0);
  const wrapRef = useRef(null);
  const fb = String(fallbackUrl || '').trim();

  const src =
    step === 0
      ? `/api/assets/${assetId}/thumbnail`
      : step === 1
        ? `/api/assets/${assetId}/download`
        : fb;
  const alt = title ? `${title} musical notation` : 'Musical notation';

  return (
    <span ref={wrapRef} className="notation-asset-img-slot">
      <img
        key={`${assetId}-${step}-${src}`}
        src={src}
        alt={alt}
        onError={() => {
          if (step === 0) {
            setStep(1);
            return;
          }
          if (step === 1 && fb) {
            setStep(2);
            return;
          }
          if (hideSectionOnTotalFailure && wrapRef.current) {
            wrapRef.current.style.display = 'none';
          }
        }}
      />
    </span>
  );
}
